import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { RouteApplicationStartupResolveService } from '../../core/route-application-startup-resolve.service';
import { PaymentLookupResolveService } from './shared/services/payment-lookup-resolve.service';
import { PaymentShellComponent } from './payment-shell/payment-shell.component';
import { PaymentListComponent } from './payment-list/payment-list.component';

const paymentsRoutes: Routes = [
  // {
  //     path: 'payments',
  //     component: PaymentShellComponent,
  //     resolve:{
  //         appData: RouteApplicationStartupResolveService,
  //         lookupData: PaymentLookupResolveService
  //     },
  //     children:[
  //         {
  //             path: '',
  //             redirectTo: 'list',
  //             pathMatch: 'full'
  //         },
  //         {
  //             path: 'list',
  //             component: PaymentListComponent
  //         }
  //     ]
  // }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(paymentsRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class PaymentsRoutingModule {}
